// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"51b202ab","977":"34906c3b"}[chunkId] + ".chunk.js";
};